<template>
    <CCardTitle>
        <slot />
    </CCardTitle>
</template>

<script setup>
import { CCardTitle } from '@coreui/vue-pro'
</script>

<style scoped>

</style>
